<ng-content *ngIf="!showLoader() || showBackgroundComponent()"></ng-content>

<div class="relative top-0 h-full w-full" *ngIf="showLoader()">
  <div
    class="absolute z-20 flex h-full w-full items-center justify-center bg-opacity-30"
    [class]="background() ? 'bg-surface-500' : ''"
    [ngStyle]="{ borderRadius: loaderState.borderRadius() }">
    <p-progress-spinner
      strokeWidth="8"
      fill="transparent"
      animationDuration=".5s"
      [style]="{ width: '50px', height: '50px' }" />
  </div>
</div>
